import { AppState, AppStateActionParams } from 'records/AppState';

export interface DisciplineActions {
  getDisciplines: (
    actionParams: AppStateActionParams,
    projectid: string
  ) => Promise<AppState>;
}

const disciplineActions: DisciplineActions = {
  getDisciplines: async ({
    state,
  }: AppStateActionParams): Promise<AppState> => {
    return state();
  },
};

export default disciplineActions;
